import ConsumerSettingsService from "@/services/ConsumerSettingsService";

export default {
    state() {
        return {
            status: null,
            consumerSettings: {},
            consumerCallendarColorHash: {
                '#FF4500': 'orange',
                '#EE751C': 'orange',
                '#1A5276': 'blue',
                '#347dbd': 'blue',
                '#23761a': 'green',
                '#34bd6b': 'green',
                '#aa00ff': 'purple',
                '#6F42C1': 'indigo',
                '#ff0026': 'red',
                '#DC3545': 'red',
                '#FFC107': 'yellow',
                '#6C757D': 'gray'
            }
        }
    },

    getters: {
        getConsumerColors: (state) => ({
            primary_color: state?.consumerSettings?.settings?.primary_color,
            secondary_color: state?.consumerSettings?.settings?.secondary_color
        }),
        getConsumerCompanyName: (state) => state?.consumerSettings?.settings?.name,
        getConsumerSettings: state => state?.consumerSettings,
        getConsumerName: (state) => state?.consumerSettings?.settings?.name,
        getConsumerId: (state) => state?.consumerSettings?.settings?.consumer_id,
    },

    mutations: {
        setConsumerSettings(state, data) {
            const vCallendarColor = state.consumerCallendarColorHash[data?.settings?.primary_color] || 'gray'
            data?.settings && (data.settings.vCallendarColor = vCallendarColor)

            state.consumerSettings = {
                ...data,
                original_primary_color: data?.settings?.primary_color || '#1A5276',
                original_secondary_color: data?.settings?.secondary_color || '#EE751C',
            };

        },

        editConsumerColors(state, payload) {
            state?.consumerSettings?.settings?.primary_color && (state.consumerSettings.settings.primary_color = payload.primary_color)
            state?.consumerSettings?.settings?.secondary_color && (state.consumerSettings.settings.secondary_color = payload.secondary_color)
        },
    },
    actions: {
        editConsumerColors({ commit }, data) {
            commit('editConsumerColors', data)
        },

        setConsumerSettings({ commit }, data) {
            commit('setConsumerSettings', data);
        },

        async getConsumerSettings({ commit }, payload) {
            try {
                const response = await ConsumerSettingsService.getConsumerSettings(payload.userToken);

                commit('setConsumerSettings', response.data);

                return response.data;
            } catch (error) {
                console.error('Erro ao buscar configurações do consumidor:', error);
                throw error;
            }
        },

        async updateConsumerSettings({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'consumerSettingsView' }, { root: true });
                const response = await ConsumerSettingsService.updateConsumerSettings(payload.data, payload.userToken);
                commit('setConsumerSettings', { settings: response.data })
                dispatch('toastfy/activeSuccesNotification', { text: 'Configurações atualizadas com sucesso!' })
                return response.data
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            } finally {
                dispatch('setLoadingState', { loadignState: false }, { root: true });
            }
        }
    }
}